module.exports = __webpack_public_path__ + "img/gb9116_25.prt.d0a11b2a.jpg";